"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteContent = void 0;
var _components = require("@ori-ui/components");
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _constants = require("../../constants");
var _favoritesContext = require("../../contexts/favoritesContext");
var _hooks = require("../../hooks");
var _FavoritesDialogContent = require("../FavoritesDialogContent/FavoritesDialogContent");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DeleteContent = ({
  lastUsedListId,
  shouldRedirectOnSuccess,
  onDialogClose
}) => {
  const {
    customerId
  } = (0, _auth.useToken)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    translations,
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getList,
    openSnackbar,
    updateLists
  } = (0, _favoritesContext.useFavorites)();
  const list = getList(lastUsedListId);
  const onDeleteList = (0, _react.useCallback)(async () => {
    try {
      await (0, _globalApiClientReact.deleteCustomerProductListTypeProductList)(globalApiClient, customerId, 'Personal', lastUsedListId);
      openSnackbar(translations.deleteSuccess);
      // istanbul ignore next -- We are not testing the else case
      updateLists(lists => lists.filter(({
        id
      }) => id !== lastUsedListId));
      if (shouldRedirectOnSuccess) {
        window.location.href = _constants.FAVORITE_LISTS_LANDING_PAGE;
      }
    } catch (error) {
      openSnackbar(translations.deleteFailed);
    } finally {
      onDialogClose();
    }
  }, [customerId, globalApiClient, lastUsedListId, onDialogClose, openSnackbar, shouldRedirectOnSuccess, translations.deleteFailed, translations.deleteSuccess, updateLists]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FavoritesDialogContent.FavoritesDialogContent, {
    testId: _constants2.DELETE_CONTENT,
    message: formatMessage('deleteDescription', {
      listName: list?.name
    }),
    content: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Buttons, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        variant: "contained",
        color: "error",
        onClick: onDeleteList,
        children: translations.delete
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        variant: "text",
        onClick: onDialogClose,
        children: translations.cancel
      })]
    })
  });
};
exports.DeleteContent = DeleteContent;
//# sourceMappingURL=DeleteContent.js.map